import React from 'react'
import { Translate } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

const ReservationInfo = ({ reservation }) => {
  const dateTimeFormat = I18n.t('date.shortDateTimeFormat')

  if (!reservation.confirmationNumber) return null

  return (
    <div className="p-4">
      {/* Confirmation Number & Main Passenger */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.confirmationNumber" />
          </label>
          <p className="text-gray-900 text-sm font-medium">
            {reservation.confirmationNumber}
          </p>
        </div>
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.mainPaxName" />
          </label>
          <p className="text-gray-900 text-sm">
            {reservation.mainPax.fullName}
          </p>
        </div>
      </div>

      {/* Flight Number & Luggage */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.flightNumber" />
          </label>
          <p className="text-gray-900 text-sm">{reservation.flightNumber}</p>
        </div>
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.luggageAmount" />
          </label>
          <p className="text-gray-900 text-sm">
            {reservation.luggageAmount ? reservation.luggageAmount : '0'}
          </p>
        </div>
      </div>

      {/* Service Time & Boarding Time */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.serviceDateTime" />
          </label>
          <p className="text-gray-900 text-sm">
            {reservation.serviceDateTime &&
              reservation.serviceDateTime.format(dateTimeFormat)}
          </p>
        </div>
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.boardingDateTime" />
          </label>
          <p className="text-gray-900 text-sm">
            {reservation.boardingDateTime &&
              reservation.boardingDateTime.format(dateTimeFormat)}
          </p>
        </div>
      </div>

      {/* Stations */}
      <div className="mb-4">
        <label className="block text-gray-600 text-xs font-medium mb-1">
          <Translate value="checkInScene.reservation.targetStationsByService" />
        </label>
        <p className="text-gray-900 text-sm">
          {reservation.targetStationsByService &&
            makeStationByServiceTitle(reservation.targetStationsByService)}
        </p>
      </div>

      {/* Guest Count */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.guestPaxAdult" />
          </label>
          <p className="text-gray-900 text-sm font-medium">
            {reservation && reservation.guestPaxAdult}
          </p>
        </div>
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.guestPaxChild" />
          </label>
          <p className="text-gray-900 text-sm font-medium">
            {reservation && reservation.guestPaxChild}
          </p>
        </div>
        <div>
          <label className="block text-gray-600 text-xs font-medium mb-1">
            <Translate value="checkInScene.reservation.guestPaxInfant" />
          </label>
          <p className="text-gray-900 text-sm font-medium">
            {reservation && reservation.guestPaxInfant}
          </p>
        </div>
      </div>

      {/* Important Note */}
      <div className="mb-4">
        <label className="block text-gray-600 text-xs font-medium mb-1">
          <Translate value="checkInScene.reservation.importantNote" />
        </label>
        <p className="text-gray-900 text-sm whitespace-pre-wrap">
          {reservation.importantNote ? reservation.importantNote : '-'}
        </p>
      </div>

      {/* Private Note */}
      <div className="mb-4">
        <label className="block text-gray-600 text-xs font-medium mb-1">
          <Translate value="checkInScene.reservation.privateNote" />
        </label>
        <p className="text-gray-900 text-sm whitespace-pre-wrap">
          {reservation.privateNote ? reservation.privateNote : '-'}
        </p>
      </div>

      {/* Public Note */}
      <div>
        <label className="block text-gray-600 text-xs font-medium mb-1">
          <Translate value="checkInScene.reservation.publicNote" />
        </label>
        <p className="text-gray-900 text-sm whitespace-pre-wrap">
          {reservation.publicNote ? reservation.publicNote : '-'}
        </p>
      </div>
    </div>
  )
}

export const makeStationByServiceTitle = (stationByService) =>
  stationByService
    .filter((target) => target.station)
    .map((target) => target.station.name)
    .join(', ')

export default connect(({ checkin }) => ({
  reservation: checkin.serviceTxn.reservation,
}))(ReservationInfo)
